import * as _4 from 'lodash4';
import { PathItem } from '../../data/builders/path_item_builder';
import { PathTask } from '../../data/builders/path_task_builder';
import { PathTopic } from '../../data/builders/path_topic_builder';
import { PathTitleColorService } from '../../data/services/path_color_service';

export class ConsiderTodoCardController {
  private task: PathTask;
  private topic: PathTopic;
  private item: PathItem;
  private titleColorClass: string;
  private uniqId: string;

  constructor(
    private $state: ng.ui.IStateService,
    private ngPathTaskFormatter: any,
    private pathTitleColorService: PathTitleColorService
  ) {}

  $onInit(): void {
    this.titleColorClass = this.pathTitleColorService.getTextColorClass(this.getSuperTitle());
    this.uniqId = _4.uniqueId();
  }

  getSuperTitle(): string {
    return !_4.isEmpty(this.topic) ? this.topic.name : '';
  }

  getTitle(): string {
    if (this.task.substitute_text_by_field_by_item && this.task.substitute_text_by_field_by_item[this.item.id]) {
      return this.task.substitute_text_by_field_by_item[this.item.id].title;
    }
    return this.item.title;
  }

  isAppointment(): boolean {
    return this.ngPathTaskFormatter.isAppointment(this.task, this.item);
  }
  isAppointmentRequest(): boolean {
    return this.ngPathTaskFormatter.isAppointmentRequest(this.task, this.item);
  }
  isArticle(): boolean {
    return this.ngPathTaskFormatter.isArticle(this.task, this.item);
  }
  isPlacementTest(): boolean {
    return this.ngPathTaskFormatter.isPlacementTest(this.task, this.item);
  }

  get stateUri(): string {
    const data = {
      eventId: this.task.event,
      repeatedBy: this.task.repeated_by,
      topic: _4.get(this.topic, 'name')
    };
    return `${this.getStateName()}(${JSON.stringify(data)})`;
  }

  getStateName(): string {
    if (this.isAppointment()) {
      return 'my.todos.appointment';
    } else if (this.isAppointmentRequest()) {
      return 'my.todos.appointmentRequest';
    } else if (this.isPlacementTest()) {
      return 'my.todos.placement';
    } else {
      return 'my.todos.details';
    }
  }
}

export class ConsiderTodoComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-todos/src/components/consider_todo_card/consider_todo_card.html';
  public controller: any = ConsiderTodoCardController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    task: '<',
    item: '<',
    topic: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/components/consider_todo_card/consider_todo_card.ts